var map = {
	"./i-con.png": "1899",
	"./i-cont.png": "3535",
	"./i-dig.png": "fedc",
	"./i-doc.png": "2d6e",
	"./i-fact.png": "5228",
	"./i-imp.png": "b53d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6612";